// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3U-nv","fileBtn":"File_fileBtn__2xyuK","closeBtn":"File_closeBtn__3bPEu","fileSelected":"File_fileSelected__1XJF7","disabled":"File_disabled__2fjY5"};